module.exports = __webpack_public_path__ + "static/media/empty-state-sector-defects.c73bb078.svg";